import { nodeType } from "../constants"

const getTempFilterNodeIndexes = (nodes) =>
  nodes.reduce((reducedTempFilterNodeIndexes, node, index) => {
    if (node.type !== nodeType.filterOperator || node.isInitialized) {
      return reducedTempFilterNodeIndexes
    }

    return [...reducedTempFilterNodeIndexes, index]
  }, [])

const isFilterOperatorValueNode = (node) => node.type === nodeType.plainText

const initializeTempFilterNode = (node, index, array) => {
  if (node.type !== nodeType.filterOperator || node.isInitialized) {
    return node
  }

  if (node.key === "") {
    return {
      ...node,
      isInitialized: true,
      isEmpty: true,
    }
  }

  let valueIndex = null
  if (array.length - 1 !== index) {
    let valueNode = array[index + 1]
    if (isFilterOperatorValueNode(valueNode)) {
      valueIndex = index + 1
    }
  }

  return {
    ...node,
    isInitialized: true,
    isEmpty: valueIndex == null,
    value: valueIndex != null ? array[valueIndex] : null,
    valueIndex,
  }
}

const initializeFilterNode = (node, doAddPosition) => {
  if (node.type !== nodeType.filterOperator) {
    return node
  }

  let initializedNode = {
    type: node.type,
    key: node.key,
    value: node.value,
  }

  if (doAddPosition) {
    initializedNode = {
      ...initializedNode,
      keyStartIndex: node.keyStartIndex,
      keyEndIndex: node.keyEndIndex,
      startIndex: node.value.startIndex,
      endIndex: node.value.endIndex,
    }
  }

  return initializedNode
}

export const initializeFilterNodes = (nodes, doAddPosition) => {
  let tempFilterNodeIndexes = getTempFilterNodeIndexes(nodes)
  let duplicateTempFilterNodeIndexes = tempFilterNodeIndexes.filter(
    (value, index, array) => array.indexOf(value + 1) !== -1,
  )
  nodes = nodes.filter((node, index) => duplicateTempFilterNodeIndexes.indexOf(index) === -1)

  nodes = nodes.map((value, index, array) => initializeTempFilterNode(value, index, array))
  let indexesToRemove = nodes.reduce((reducedIndexesToRemove, node, index) => {
    if (node.type !== nodeType.filterOperator || !node.isInitialized) {
      return reducedIndexesToRemove
    }

    if (node.isEmpty) {
      return [...reducedIndexesToRemove, index]
    }
    if (node.valueIndex != null) {
      return [...reducedIndexesToRemove, node.valueIndex]
    }

    return reducedIndexesToRemove
  }, [])
  return nodes
    .filter((node, index) => indexesToRemove.indexOf(index) === -1)
    .map((node) => initializeFilterNode(node, doAddPosition))
}
